export const statusType = {
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
  TEMPORAL_DROP: 'TEMPORAL_DROP',
  DROPPED: 'DROPPED',
}


/**
 * @callback addStuffCallback
 * @param {any} value -
 * @param {object} obj -
 */
/**
 * @param {array} arrayValuesToExclude 
 * @param {array} arrayIterate 
 * @param {addStuffCallback} cb - A callback
 * @returns {array} - return an array.
 */
export function filterArrayFromArray(arrayValuesToExclude = [], arrayIterate = [], cb = (value, obj)=> {}) {
  const tempMap = new Map(arrayValuesToExclude.map((e)=> [e, e]))
  const tempObj = Object.fromEntries(tempMap)
  return arrayIterate.map((e) => cb(e, tempObj)).filter(Boolean)
}